<template>
  <router-link class="Drop-Menu-Item" :to="{name: PATHS_NAME.USER.GIFT}" @click="toClose"> 
    <GiftIcon class="Drop-Menu-Item__icon " /> Активировать подарочный код
  </router-link>
</template>

<script setup>
  import { PATHS_NAME } from "@shared/routers/consts/pathsName";
  //------------------------------------------
  import GiftIcon from "@shared/UI/SVG/GiftIcon.vue";
  //------------------------------------------
  const emit = defineEmits(['close-menu']);
  //------------------------------------------
  //Закрыть дропдаун
  const toClose = () => emit('close');
</script>

<style lang="scss">
  @import '../../../../styles/Drop-Menu-Item.scss';
</style>
